import { canRead, canWrite } from '../access/rbacAccess'

export const ROUTE_PLANS = {
  LIST: 'planifica.route_plans'
}

export const canViewRoutePlans = () => canRead(ROUTE_PLANS.LIST)

export const canManageRoutePlans = () => canWrite(ROUTE_PLANS.LIST)
